import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminTripStopGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripStopGrid = this;
		setTimeout(function(){
			tripStopGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripStopGrid = this;
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tripRefNo',
					header: 'Trip Ref No',
					width: '7em'
				},
				{						
					path: 'stopSeqNo',
					header: 'Stop Seq No',
					width: '7em'
				},
				{						
					path: 'arrivalDts',
					header: 'Arrival Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.arrivalDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'gpsArrivalDts',
					header: 'GPS Arrival Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.gpsArrivalDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stopTypeDescription',
					header: 'Stop Type',
					width: '7em'
				},
				{						
					path: 'location',
					header: 'Location',
					width: '7em',					
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.location.addressLine1 + ' ' + rowData.item.location.city + ', ' + rowData.item.location.stateProv + ' ' + rowData.item.location.country;					
					}
				},
				{						
					path: 'stopDistance',
					header: 'Stop Miles',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumStopDistance(rowData.item.stopDistance);
					}
				},				
				{						
					path: 'stopComment',
					header: 'Stop Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em',
					hidden: true
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				record.stopDistance.distances.forEach(function(d){
					var finalD = d.finalDistance;
					
					var distance = finalD.distance ? finalD.distance : 0;
					var toll = finalD.tollDistance ? finalD.tollDistance : 0;
					var ferry = finalD.ferryDistance ? record.ferryDistance : 0;

					if (record.distanceUom === 'KM') {
						totalDistance += UOMUtil.convertKMToMI(distance);
						totalToll += UOMUtil.convertKMToMI(toll);
						totalFerry += UOMUtil.convertKMToMI(ferry);
					} else {
						totalDistance += distance;
						totalToll += toll;
						totalFerry += ferry;
					}
				});
				
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Planned Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'trip-stops',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var companyId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterCompany').value;						
					if (companyId) {
						DataManagementService.getAdminDataService().exportTripStops(grid.currentFilter);					
					} else {
						ElementUtil.query(tripStopGrid.toolbarFilter, 'filterCompany').validate();
						window.DL.MessageUtil.showToastError('A Company must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
							
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(tripStopGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(tripStopGrid.toolbarFilter, 'filterEndDate').value);		
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'arrivalDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							start: startFilterDts,														
							end: endFilterDts,
							filterField: 'tripRefNo',
							filterValue: ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTripRefNo').value, 
							dateField: 'arrivalDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals;
							if (records.totatDistanceOfStops) {
								totals = {
									totalDistance: records.totatDistanceOfStops.distance,
									totalToll: records.totatDistanceOfStops.tollDistance,
									totalFerry: records.totatDistanceOfStops.ferryDistance
								};
							} else {
								totals = calcTotals(records.data);
							}
							distanceStatus.innerHTML = '<b>Planned Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						

						
						var companyId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterCompany').value;
						
						if (companyId) {
							var tractorId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').value;
							if (tractorId) {						
								DataManagementService.getAdminDataService().getTripStops(companyId, tractorId, grid.currentFilter).then(function(records){
									successHandler(records);
								});						
							} else {
								loadMask.remove();
								if (tripStopGrid.nextLoadOfGrid) {
									ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').validate();								
									window.DL.MessageUtil.showToastError('A tractor must be selected');									
								} else {
									tripStopGrid.nextLoadOfGrid = true;
								}
							}
						} else {
							loadMask.remove();
							ElementUtil.query(tripStopGrid.toolbarFilter, 'filterCompany').validate();								
							window.DL.MessageUtil.showToastError('A Company must be selected');
						}						
						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [			
				grid,
				footerContainer
			]
		});		
		tripStopGrid.append(flexLayout);	

		tripStopGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};		
	
		tripStopGrid.clearData = function() {
			grid.items = [];
		};		
	
	}
		
	refreshGrid() {
		var tripStopGrid = this;		
		tripStopGrid.actionRefresh();
	}
	
	clearGrid() {
		var tripStopGrid = this;
		tripStopGrid.clearData();
	}	
	
	setFilterContainer(filterContainer) {
		var tripStopGrid = this;		
		tripStopGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-admin-trip-stops-grid', AdminTripStopGrid);
